(() => {
  const initMenu = () => {
    const button = document.querySelector('[data-menu-button]');
    const nav = document.querySelector('[data-site-menu]');
    if (!button || !nav) return;
    const setOpen = (open) => {
      nav.classList.toggle('nav-open', open);
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? 'Close' : 'Index';
    };
    button.addEventListener('click', () => setOpen(!nav.classList.contains('nav-open')));
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => event.key === 'Escape' && setOpen(false));
  };

  const initRepairMap = () => {
    const shell = document.querySelector('[data-part92-shell]');
    if (!shell) return;
    const trigger = shell.querySelector('[data-camera-trigger]');
    const close = shell.querySelector('[data-inspection-close]');
    const label = shell.querySelector('[data-click-label]');
    const mapLinks = shell.querySelectorAll('[data-repair-code]');
    const hotspots = shell.querySelectorAll('[data-hotspot-code]');

    const setInspection = (open) => {
      shell.classList.toggle('is-inspecting', open);
      trigger?.setAttribute('aria-pressed', String(open));
      trigger?.setAttribute('aria-label', open ? 'Close accurate Ricoh GR exploded view' : 'Open accurate Ricoh GR exploded view');
      if (label) label.textContent = open ? 'Return to camera' : 'Explore repair map';
      if (!open) setActive(null);
    };
    const setActive = (code) => {
      mapLinks.forEach((item) => item.classList.toggle('is-active', item.dataset.repairCode === code));
      hotspots.forEach((item) => item.classList.toggle('is-active', item.dataset.hotspotCode === code));
    };

    trigger?.addEventListener('click', () => setInspection(!shell.classList.contains('is-inspecting')));
    close?.addEventListener('click', () => setInspection(false));
    mapLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => setActive(link.dataset.repairCode));
      link.addEventListener('mouseleave', () => setActive(null));
      link.addEventListener('focus', () => setActive(link.dataset.repairCode));
      link.addEventListener('blur', () => setActive(null));
    });
    document.addEventListener('keydown', (event) => event.key === 'Escape' && setInspection(false));
  };

  const initLocalization = () => {
    document.querySelectorAll('[data-localization-select]').forEach((select) => {
      select.addEventListener('change', () => select.form?.submit());
    });
  };

  const init = () => { initMenu(); initRepairMap(); initLocalization(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();